/**
 * @fileoverview CSS module for rendering browser instructions and icons
 *
 * @example
 * // Usage in component:
 * import styles from './BrowserInstructionsRenderer.module.css';
 *
 * <div className={styles.browser_title}>
 *   <img className={styles.browser_icon} src="browser.png" alt="Browser icon"/>
 *   <span>Browser Instructions</span>
 * </div>
 */


.browser_title {
    margin-top: 8px;
    display: flex;
    align-items: center;
    gap: 16px;
}

.browser_icon {
    object-fit: none;
    object-position: 0px 0px;
    width: 32px;
    height: 32px;
}
